import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  metricConfigSelector,
  errorCodeSelector,
} from './store/selector';
import {
  deleteMetricsConfigFailureApiAction,
  deleteMetricsConfigInitApiAction,
  deleteMetricsConfigSuccessApiAction,
  getMetricsConfigFailureApiAction,
  getMetricsConfigInitApiAction,
  getMetricsConfigSuccessApiAction,
  postMetricsConfigFailureApiAction,
  postMetricsConfigInitApiAction,
  postMetricsConfigSuccessApiAction,
  putMetricsConfigFailureApiAction,
  putMetricsConfigInitApiAction,
  putMetricsConfigSuccessApiAction
} from './store/reducer';
import { metricsApiService } from './services/api';
import { MetricConfigurationCreate } from './interfaces/post-metrics-config';

export function useMetricsConfigCore() {
  const errorCode = useSelector(errorCodeSelector);
  const metricsConfig = useSelector(metricConfigSelector);
  const dispatch = useDispatch();

  const getMetricsConfig = useCallback(
    async (
      id: string,
      onSuccess?: () => void,
      onError?: () => void
    ) => {
      try {
        dispatch(getMetricsConfigInitApiAction());
        const response = await metricsApiService.getMetricsConfig(id);
        dispatch(getMetricsConfigSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onError?.();
        dispatch(
          getMetricsConfigFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postMetricsConfig = useCallback(
    async (
      id: string,
      body: MetricConfigurationCreate,
      onSuccess?: () => void
    ) => {
      try {
        dispatch(postMetricsConfigInitApiAction());
        await metricsApiService.postMetricsConfig(id, body);
        dispatch(postMetricsConfigSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        dispatch(postMetricsConfigFailureApiAction(error));
      }
    },
    [dispatch]
  );

  const putMetricsConfig = useCallback(
    async (
      id: string,
      idConfig: string,
      body: MetricConfigurationCreate,
      onSuccess?: () => void
    ) => {
      try {
        dispatch(putMetricsConfigInitApiAction());
        await metricsApiService.putMetricsConfig(id,idConfig, body);
        dispatch(putMetricsConfigSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        dispatch(putMetricsConfigFailureApiAction(error));
      }
    },
    [dispatch]
  );

  const deleteMetricsConfig = useCallback(
    async (
      id: string,
      idConfig: string,
      onSuccess?: () => void
    ) => {
      try {
        dispatch(deleteMetricsConfigInitApiAction());
        await metricsApiService.deleteMetricsConfig(id,idConfig);
        dispatch(deleteMetricsConfigSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        dispatch(deleteMetricsConfigFailureApiAction(error));
      }
    },
    [dispatch]
  );

  return {
    errorCode,
    metricsConfig,
    getMetricsConfig,
    postMetricsConfig,
    putMetricsConfig,
    deleteMetricsConfig
  };
}
